import VueI18n from 'vue-i18n';
import awsServiceMutation from '@/store/modules/cloud/aws/aws.mutation';
import awsServiceActions from '@/store/modules/cloud/aws/aws.action';

type AvaliableSlug = 'rds' | 'lambda' | 'elasticCache' | 'fargate' | 'ingress';

interface Services {
  id: number;
  slug: AvaliableSlug;
  isMonitoringEnabled: boolean;
  title: VueI18n.TranslateResult;
  description: VueI18n.TranslateResult;
  showAutoInstall: boolean;
  imgSrc: any;
  dataCapturingStatus: boolean;
}

export interface AwsServiceState {
  allServices: Services[];
  installedServices: Services[];
  availableServices: Services[];
  installedSlugs: AvaliableSlug[];
  isMonitoringEnabledForAll: boolean;
  slugsOfInstalledServices: AvaliableSlug[];
}

const initialState = {
};

export default {
  namespaced: true,
  state: initialState,
  mutations: awsServiceMutation,
  actions: awsServiceActions,
};
